/**完成订单 评价订单**/
<template>
  <div class="capitalRecordList" @click="clickFn">
    <div class="rows time">
      <span class="time">
        {{time}}
      </span>
    </div>
    <div class="rows clear">
      <span class="Type">
        {{type}}
      </span>
      <span class="Sum" :class="sum<0?'SumRed':''">
        {{sum}}元
      </span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'xk-capitalRecordList',
    props: ['time', 'type', 'sum'],
    computed: {},
    data () {
      return {}
    },
    methods: {
      clickFn: function () {
        this.$emit('click')
      }
    },
    watch: {},
    mounted: function () {}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .capitalRecordList {
    box-sizing: border-box;
    width: 100%;
    padding: 0 1.3rem;
    height: 7rem;
    position: relative;
    .rows {
      width: 100%;
    }
    .time {
      font-size: 1.5rem;
      color: #333;
      margin-bottom: 0.3rem;
      position: relative;
    }
    .Type, .Sum {
      font-size: 1.2rem;
      color: #999;
    }
    .Type {
      float: left;
    }
    .Sum {
      float: right;
    }
    .SumRed {
      color: #f06553;
    }
  }

  .capitalRecordList:after {
    content: '';
    width: 1px;
    height: 100%;
    background-color: rgba(0, 0, 0, .1);
    position: absolute;
    left: 0;
    top: 0.6rem;
  }

  .capitalRecordList:before {
    content: '';
    width: 0.8rem;
    height: 0.8rem;
    background-color: #f06553;
    border-radius: 50%;
    position: absolute;
    left: -0.4rem;
    top: 0.55rem;
    z-index: 5;
  }
</style>



// WEBPACK FOOTER //
// capitalRecordList.vue?45ad5eea